import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import SaftyTipsView from '../views/SaftyTipsView.vue';
import ContactView from '../views/ContactView.vue';
import ProductView from '../views/ProductView.vue';
import WholesaleView from '../views/WholesaleView.vue';
import GiftboxView from '../views/GiftboxView.vue';
import FamilypackView from '../views/FamilypackView.vue';
const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'product',
    component: ProductView
  },
  {
    path: '/wholesale',
    name: 'wholesale',
    component: WholesaleView
  },
  {
    path: '/giftbox',
    name: 'giftbox',
    component: GiftboxView
  },
  {
    path: '/familypack',
    name: 'familypack',
    component: FamilypackView
  },
  {
    path: '/safetytips',
    name: 'safetytips',
    component: SaftyTipsView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})




export default router
